const init = (timerId) => {
  const $countdownTimer = $(timerId);
  const date = $countdownTimer.data('date-time').replace(/-/g, '/');
  const hideTimer = $countdownTimer.data('hide-timer');
  const timeZone = $countdownTimer.data('timezone');
  const daysLabel = $countdownTimer.data('days-label');
  const hoursLabel = $countdownTimer.data('hours-label');
  const minutesLabel = $countdownTimer.data('minutes-label');
  const secondsLabel = $countdownTimer.data('seconds-label');
  const countDownDate = new Date(date).getTime();
  // Get today's date and time with corresponse to given timezone
  const now = new Date(new Date().toLocaleString('en-US', { timeZone: timeZone }));

  const initiateCountdown = setInterval(function () {
    // Find the distance between now and the count down date
    const distance = countDownDate - now.getTime();
    // Increasing now time by one second
    now.setSeconds(now.getSeconds() + 1);
    let days = 0;
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if (distance >= 0) {
      // Time calculations for days, hours, minutes and seconds
      days = Math.floor(distance / (1000 * 60 * 60 * 24));
      hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      seconds = Math.floor((distance % (1000 * 60)) / 1000);
    }

    $countdownTimer.html(
      `<div class="timer-box"><div class="countdown-number">${days}</div><div class="countdown-label">${daysLabel}</div></div>
      <div class="timer-box"><div class="countdown-number">${hours}</div><div class="countdown-label">${hoursLabel}</div></div>
      <div class="timer-box"><div class="countdown-number">${minutes}</div><div class="countdown-label">${minutesLabel}</div></div>
      <div class="timer-box"><div class="countdown-number">${seconds}</div><div class="countdown-label">${secondsLabel}</div></div>`
    );

    // If the count down is over, write some text
    if (distance < 0) {
      clearInterval(initiateCountdown);

      if (hideTimer === 'yes') {
        $countdownTimer.parent('.countdown-timer-wrapper').fadeOut();
        // If timer is inside section widget hide section also
        $countdownTimer.parents('.section-countdown-timer').fadeOut();
      }
    }
  }, 1000);
};
export default { init };
